import { createAction, createReducer, createSelector } from '@reduxjs/toolkit';
import { MODES } from 'common/components/AccessManager/Constants';
import { StorytellerState } from 'store/StorytellerReduxState';

export interface AccessManagerState {
  isOpen: boolean;
  mode: MODES | null;
}

const initialState: AccessManagerState = {
  isOpen: false,
  mode: null,
};

/* Action Creators */
export const openAccessManager = createAction('ACCESS_MANAGER_OPEN', (mode: MODES) => ({
  payload: { mode },
}));

export const closeAccessManager = createAction('ACCESS_MANAGER_CLOSE');

export const accessManagerReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(openAccessManager, (state, action) => {
      state.isOpen = true;
      state.mode = action.payload.mode;
    })
    .addCase(closeAccessManager, (state) => {
      state.isOpen = false;
      state.mode = null;
    });
});

/* Selectors */
export const selectAccessManagerSlice = (state: StorytellerState) => state.accessManager;

export const selectIsAccessManagerOpen = createSelector(
  selectAccessManagerSlice,
  (accessManager) => accessManager.isOpen,
);

export const selectAccessManagerMode = createSelector(
  selectAccessManagerSlice,
  (accessManager) => accessManager.mode,
);
